"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchParamsChanged = exports.getCurrentURL = void 0;
var getCurrentURL = function (location) {
    return "".concat(location.pathname).concat(location.search);
};
exports.getCurrentURL = getCurrentURL;
var searchParamsChanged = function (originalParams, newParams) {
    var e_1, _a;
    if (__spreadArray([], __read(new Set(originalParams.keys())), false).length !==
        __spreadArray([], __read(new Set(newParams.keys())), false).length) {
        return true;
    }
    try {
        for (var _b = __values(originalParams.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (newParams.get(key) !== value) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
};
exports.searchParamsChanged = searchParamsChanged;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vdXRpbHMvdXJsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVPLElBQU0sYUFBYSxHQUFHLFVBQUMsUUFBMkI7SUFDdkQsT0FBTyxVQUFHLFFBQVEsQ0FBQyxRQUFRLFNBQUcsUUFBUSxDQUFDLE1BQU0sQ0FBRSxDQUFDO0FBQ2xELENBQUMsQ0FBQztBQUZXLFFBQUEsYUFBYSxpQkFFeEI7QUFFSyxJQUFNLG1CQUFtQixHQUFHLFVBQ2pDLGNBQStCLEVBQy9CLFNBQTBCOztJQUUxQixJQUNFLHlCQUFJLElBQUksR0FBRyxDQUFDLGNBQWMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxVQUFFLE1BQU07UUFDMUMseUJBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxDQUFDLFVBQUUsTUFBTSxFQUNyQyxDQUFDO1FBQ0QsT0FBTyxJQUFJLENBQUM7SUFDZCxDQUFDOztRQUVELEtBQTJCLElBQUEsS0FBQSxTQUFBLGNBQWMsQ0FBQyxPQUFPLEVBQUUsQ0FBQSxnQkFBQSw0QkFBRSxDQUFDO1lBQTNDLElBQUEsS0FBQSxtQkFBWSxFQUFYLEdBQUcsUUFBQSxFQUFFLEtBQUssUUFBQTtZQUNwQixJQUFJLFNBQVMsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLEtBQUssS0FBSyxFQUFFLENBQUM7Z0JBQ2pDLE9BQU8sSUFBSSxDQUFDO1lBQ2QsQ0FBQztRQUNILENBQUM7Ozs7Ozs7OztJQUVELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBbEJXLFFBQUEsbUJBQW1CLHVCQWtCOUIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBMb2NhdGlvbiB9IGZyb20gXCJoaXN0b3J5XCI7XG5cbmV4cG9ydCBjb25zdCBnZXRDdXJyZW50VVJMID0gKGxvY2F0aW9uOiBMb2NhdGlvbjx1bmtub3duPik6IHN0cmluZyA9PiB7XG4gIHJldHVybiBgJHtsb2NhdGlvbi5wYXRobmFtZX0ke2xvY2F0aW9uLnNlYXJjaH1gO1xufTtcblxuZXhwb3J0IGNvbnN0IHNlYXJjaFBhcmFtc0NoYW5nZWQgPSAoXG4gIG9yaWdpbmFsUGFyYW1zOiBVUkxTZWFyY2hQYXJhbXMsXG4gIG5ld1BhcmFtczogVVJMU2VhcmNoUGFyYW1zXG4pOiBib29sZWFuID0+IHtcbiAgaWYgKFxuICAgIFsuLi5uZXcgU2V0KG9yaWdpbmFsUGFyYW1zLmtleXMoKSldLmxlbmd0aCAhPT1cbiAgICBbLi4ubmV3IFNldChuZXdQYXJhbXMua2V5cygpKV0ubGVuZ3RoXG4gICkge1xuICAgIHJldHVybiB0cnVlO1xuICB9XG5cbiAgZm9yIChjb25zdCBba2V5LCB2YWx1ZV0gb2Ygb3JpZ2luYWxQYXJhbXMuZW50cmllcygpKSB7XG4gICAgaWYgKG5ld1BhcmFtcy5nZXQoa2V5KSAhPT0gdmFsdWUpIHtcbiAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cbiAgfVxuXG4gIHJldHVybiBmYWxzZTtcbn07XG4iXX0=